import React from "react";
import { connect } from "react-redux";
import Navbar from "../components/Navbar/Navbar";
import { Sidebar } from "../components/Sidebar";
import sidebarMenus from "../constants/sidebarMenus";
import "./layout.css";
import { BannerAlert } from "../components/BannerAlert";
import { getStorage } from "../utils/storage";
import { Modal } from "../components/Modal";
import AccountStatus from "../components/Profile/AccountStatus";

class HomeDashboardLayout extends React.Component {
  state = {
    showAccountModal: false,
  };
  componentDidMount = async () => {
    const userLoggedIn = await getStorage();

    const { verified } = userLoggedIn;

    if (!verified) return this.handleShowModal("showAccountModal");
  };

  handleShowModal(modal) {
    this.setState({
      [modal]: true,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }
  render() {
    return (
      <>
        <Navbar className="container-fluid" type="dashboard" isLight />
        <div className="home-dashboard-layout-container ">
          <Sidebar
            {...this.props}
            menus={this.props.menus || sidebarMenus(this.props.defaultLanguage)}
          />
          <div className="dashboard-layout">
            <BannerAlert />
            <div className="card-body"> {this.props.children}</div>
          </div>
        </div>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showAccountModal")}
          show={this.state.showAccountModal}
          showHeaderBottomBorder={false}
        >
          <AccountStatus
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showAccountModal"
            )}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { verifications } = state.Verifications;
  return {
    defaultLanguage,
    verifications,
  };
};

export default connect(mapStateToProps)(HomeDashboardLayout);
